import { Link } from "react-router-dom";
import { Box, Tab, Tabs } from "@mui/material";
import TabPanel from "../../../../../components/tabs/Tabs";
import BreadCrumb from "../../../../../components/navbar/Breadcrumb";
import Ventas from "../../../general/Ventas";
import { cambiarFormatoNombre } from "../../../../../functions/funciones";

const Comunidad = ({
  t,
  finca,
  proveedores,
  value,
  handleChange,
  nif,
}) => {
  return (
    <>
      <BreadCrumb
        rutas={[
          { path: "/comunidades/", label: t("title") },
          { path: `/comunidades/${nif}`, label: `${finca?.razonSocial}` },
        ]}
        style={{ margin: "0 10px" }}
      />
      <div className="pageContent">
        <div className="gridCard">
          <div className="gridHead">{t("details.generalInfo")}</div>
          <div className="gridSubhead">{t("details.communityData")}</div>
          <div className="datosGrid">
            <p>
              <b>{t("details.communityName")}:</b> {finca?.razonSocial}
            </p>
            <p>
              <b>{t("common:form.address")}:</b> {finca?.direccion}
            </p>
            <p>
              <b>{t("common:form.nif")}:</b> {finca?.nif}
            </p>
            <p>
              <b>{t("columns.municipality")}:</b>{" "}
              {cambiarFormatoNombre(finca?.municipio)}
            </p>
            <p>
              <b>{t("details.contactPerson")}:</b>{" "}
            </p>
            <p>
              <b>{t("common:form.postalCode")}:</b> {finca?.codigoPostal}
            </p>
            <p>
              <b>{t("common:form.email")}:</b> {finca?.email}
            </p>
            <p>
              <b>{t("common:form.province")}:</b> {finca?.provincia}
            </p>
            <p>
              <b>{t("common:form.phone")}:</b> {finca?.telefonoContacto}{" "}
            </p>
            <p>
              <b>{t("details.president")}:</b> {finca?.nombrePresidente}{" "}
            </p>
          </div>
          <div style={{ paddingBottom: "5%" }}>
            <div className="gridSubhead">{t("details.communityServices")}</div>
            <Box sx={{ padding: "10px 40px", border: "none" }}>
              {!finca?.gruposServicios ||
              finca?.gruposServicios.length === 0 ? (
                t("noDocuments")
              ) : (
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="tabs example"
                >
                  {finca?.gruposServicios?.includes(1) && (
                    <Tab
                      style={{ color: "#92004D" }}
                      label="CAE"
                      value={1}
                    />
                  )}
                  {finca?.gruposServicios?.includes(2) && (
                    <Tab
                      style={{ color: "#92004D" }}
                      label="LOPD"
                      value={2}
                    />
                  )}
                  {finca?.gruposServicios?.includes(3) && (
                    <Tab
                      style={{ color: "#92004D" }}
                      label="CAI"
                      value={3}
                    />
                  )}
                </Tabs>
              )}
            </Box>
            {finca?.gruposServicios?.map((grupoServicio) => (
              <TabPanel key={grupoServicio} value={value} index={grupoServicio}>
                <div className="pageGrid" style={{ gap: 0 }}>
                  {grupoServicio === 1 && (
                    <>
                      <div id="ventas">
                        <Ventas
                          nifFinca={nif}
                          idFinca={finca.id}
                          grupoServicio={1}
                        />
                      </div>
                      <div id="proveedores" className="tableContainer">
                        <div className="gridHeadProv">
                          {t("suppliers:title").toUpperCase()}
                        </div>
                        <div>
                          <table>
                            <tbody>
                              {proveedores.length === 0 ? (
                                <small style={{ paddingLeft: "14px" }}>
                                  {t("suppliers:noSuppliers")}
                                </small>
                              ) : (
                                proveedores.map((e, i) => {
                                  return (
                                    <tr key={i}>
                                      <td
                                        style={{
                                          width: "100%",
                                          padding: 10,
                                        }}
                                      >
                                        <Link to={"/proveedores/" + e.nif}>
                                          {e.razonSocial}
                                          <p
                                            style={{
                                              opacity: 0.55,
                                              fontSize: 14,
                                            }}
                                          >
                                            {e?.serviceSupps?.length > 0
                                              ? e?.serviceSupps?.find(
                                                  (serv) =>
                                                    serv.id ===
                                                    e.service_to_propertie
                                                      ?.service
                                                )?.nombre
                                              : null}
                                          </p>
                                        </Link>
                                      </td>
                                    </tr>
                                  );
                                })
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </>
                  )}
                  {grupoServicio === 2 && (
                    <Ventas nifFinca={nif} grupoServicio={2} />
                  )}
                  {grupoServicio === 3 && (
                    <div className="caiTab" style={{ width: "100%" }}>
                      <Ventas nifFinca={nif} grupoServicio={3} />
                    </div>
                  )}
                </div>
              </TabPanel>
            ))}
          </div>
        </div>
      </div>
      <style jsx="true">{`
        .css-1aquho2-MuiTabs-indicator {
          background-color: #92004d;
        }
        .gridHeadProv {
          border-radius: 5px 5px 0 0;
          background-color: #92004d;
          color: #ffffff;
          padding: 10px 15px;
          font-weight: bold;
          font-size: 12px;
          height: 34px;
        }
        #ventas {
          width: 70%;
        }
        #proveedores {
          width: 30%;
        }
        .pageGrid {
          display: flex;
          flex-direction: row;
        }
        @media screen and (max-width: 992px) {
          #ventas {
            overflow-y: auto;
            width: 100%;
          }
          #proveedores {
            width: 100%;
          }
          .pageGrid {
            flex-direction: column;
          }
        }
      `}</style>
    </>
  );
};

export default Comunidad;
